import { Component, OnInit, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { UserInfoService } from '../../shared/services/user-info.service';
import { Subscription } from 'rxjs';
import { GlobalShadowStyleDirective } from '@ptl/global-components';

@Component({
    selector: 'app-login-and-register-widget',
    templateUrl: './login-and-register-widget.component.html',
    styleUrls: ['./login-and-register-widget.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class LoginAndRegisterWidgetComponent extends GlobalShadowStyleDirective implements OnInit, OnDestroy {

  /** Registration */
  @Input() registrationUrl: string;

  /** Login */
  @Input() producerLandingPageUrl: string;
  @Input() memberLandingPageUrl: string;
  @Input() consumerLandingPageUrl: string;
  @Input() forgotPasswordUrl: string;
  @Input() hidePreLogin: string;

  /** Post-Login */
  @Input() myAccountUrl: string;
  @Input() consumerLogoutRedirectUrl: string;
  @Input() producerLogoutRedirectUrl: string;

  isLoggedIn: boolean;
  isLoggedInSubscription: Subscription;
  hidePreloginBool: boolean;

  constructor(
    private userInfoService: UserInfoService,
  ) {
    super();
    /** Subscribe to userInfo service for emissions of logged-in or -out */
    this.isLoggedInSubscription = this.userInfoService.isLoggedIn$.subscribe(isLoggedIn => this.isLoggedIn = isLoggedIn);
  }

  ngOnInit() {
    this.hidePreloginBool = this.hidePreLogin === 'true' ? true : false;
  }

  ngOnDestroy() {
    this.isLoggedInSubscription.unsubscribe();
  }

}
